import { render, staticRenderFns } from "./BrowseAssessmentsFilters.vue?vue&type=template&id=0d23e889&scoped=true"
import script from "./BrowseAssessmentsFilters.vue?vue&type=script&lang=js"
export * from "./BrowseAssessmentsFilters.vue?vue&type=script&lang=js"
import style0 from "./BrowseAssessmentsFilters.vue?vue&type=style&index=0&id=0d23e889&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23e889",
  null
  
)

export default component.exports